import i18next from "i18next"
import { TabSearch } from "../service-inquiry/basic-search-form"
import * as t from 'io-ts'
import { form2, PulseOpsFormat } from "@pulseops/common"
import { pipe } from "fp-ts/lib/function"
import moment from "moment"

export namespace NewBasicSearchForm {
  let tab: TabSearch | null = null
  export const setTab = (tabSearch: TabSearch | null) => {
    tab = tabSearch
  }

  const MultipleSelectOption = t.array(
    t.type({
      label: t.string,
      value: t.string
    })
  )

  const Base = t.type({
    policyNumber: pipe(
      form2.string.optional,
      form2.string.minLength(8, () =>
        i18next.t('message:MS990031', { field: i18next.t('ServiceInquiry:PolicyNumber'), k: 8 })
      )
    ),
    policyNumberClaim: pipe(
      form2.string.optional,
      form2.string.minLength(8, () =>
        i18next.t('message:MS990031', { field: i18next.t('ServiceInquiry:PolicyNumber'), k: 8 })
      )
    ),
    idNumber: pipe(
      form2.string.optional,
      form2.string.minLength(2, () => i18next.t('message:MS050216'))
    ),
    clientNumber: pipe(
      form2.string.optional,
      form2.string.minLength(8, () =>
        i18next.t('message:MS990031', { field: i18next.t('ServiceInquiry:ClientNumber'), k: 8 })
      )
    ),
    phoneNumber: pipe(
      form2.string.optional,
      form2.string.minLength(10, () =>
        i18next.t('message:MS050013', { field: i18next.t('ServiceInquiry:PhoneNumber') })
      )
    ),
    source: MultipleSelectOption,
    category: form2.selectOption.optional,
    transactionType: MultipleSelectOption,
    fromDate: form2.date.requiredM(() =>
      i18next.t('message:MS020009', { field: i18next.t('ServiceInquiry:FromDate') })
    ),
    toDate: form2.date.requiredM(() => i18next.t('message:MS020009', { field: i18next.t('ServiceInquiry:ToDate') })),
    subServiceType: MultipleSelectOption,
    subTransactionType: MultipleSelectOption,
    offices: MultipleSelectOption,
    status: form2.selectOption.optional,
    claimNumber: pipe(
      form2.string.optional
      // form2.string.minLength(11, () =>
      //   i18next.t('message:MS050013', { field: i18next.t('ServiceInquiry:ClaimNumber') })
      // )
    ),
    claimTypes: t.array(
      t.type({
        label: t.string,
        value: t.string,
        codes: t.array(
          t.type({
            claimCode: t.string,
            claimType: t.string,
            claimTypeShortName: t.string,
            claimTypeVN: t.string,
            claimTypeWF: t.string,
            id: t.string
          })
        )
      })
    )
  })
  type Base = t.TypeOf<typeof Base>

  type Form = t.Branded<Base, { readonly Form: unique symbol }>

  const getDeviationDate = () => (tab === TabSearch.AdvancedSearch ? 3 : 60)

  const FormSearch = pipe(
    Base,
    form2.refine(
      (data): data is Form => {
        switch (tab) {
          case TabSearch.BasicSearch:
            return !!data.policyNumber || !!data.clientNumber || !!data.idNumber || !!data.phoneNumber
          case TabSearch.ClaimSearch:
            return !!data.policyNumberClaim || !!data.claimNumber || !!data.idNumber
          case TabSearch.CashOutSearch:
            if (data.offices.length > 0 && data.offices[0].value === 'ALL') return !!data.policyNumber
            else return true
          case TabSearch.CashOutComplete:
            if (data.offices.length > 0 && data.offices[0].value === 'ALL') return !!data.policyNumber
            else return true
          default:
            return true
        }
      },
      () => {
        switch (tab) {
          case TabSearch.ClaimSearch:
            return i18next.t('message:MS990026')
          case TabSearch.CashOutSearch:
            return i18next.t('message:MS990065')
          case TabSearch.CashOutComplete:
            return i18next.t('message:MS990065')
          default:
            return i18next.t('message:MS990025')
        }
      },
      'Form'
    ),
    form2.refine(
      (data): data is Form => moment(data.toDate).isSameOrAfter(data.fromDate, 'day'),
      () => i18next.t('message:MS030044'),
      'Form'
    ),
    form2.refine(
      (data): data is Form => {
        const dateFrom = PulseOpsFormat.startOfDate(data.fromDate)
        const dateTo = PulseOpsFormat.startOfDate(data.toDate)
        return moment(dateTo).diff(dateFrom, 'months', true) <= getDeviationDate()
      },
      () => i18next.t('message:MS080004', { k: getDeviationDate() }),
      'Form'
    )
  )

  export const codec = FormSearch

  export type Validated = t.TypeOf<typeof codec>

  export type Raw = t.OutputOf<typeof codec>
}